import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { navbarStyles } from './navbarStyles';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import { Logotype } from '../Logotype/Logotype';
import { useTranslation } from 'react-i18next';
import Paper from '@mui/material/Paper';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import LogoutIcon from '@mui/icons-material/Logout';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { disconnectWallet, getAddress } from '@brickken/web3';
import { useWallet } from '../../hooks/useWallet';
import { ToggleColorMode } from '../ToggleColorMode/ToggleColorMode';
import { ProfileMenu } from '../ProfileMenu/ProfileMenu';

export const HeaderMobile = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isDark = theme.palette.mode === 'dark';
  const classes = navbarStyles(theme, isDark);
  const { isWalletConnected } = useWallet();
  const [companyWalletAddress, setCompanyWalletAddress] = useState<string>();
  const connectDisconect = isWalletConnected
    ? t('vesting.disconnect_wallet.button')
    : t('vesting.connect_wallet.button');

  const handleWalletConnection = async () => {
    const address = await getAddress();
    if (address) {
      setCompanyWalletAddress(address);
    }
    if (isWalletConnected) {
      disconnectWallet();
      setCompanyWalletAddress(null);
      return;
    }
  };

  return (
    <>
      <Grid
        item
        container
        xs={12}
        sm={1}
        lg={1}
        sx={classes.header}
        justifyContent='space-between'
      >
        <Paper sx={classes.headerPaperMobile} elevation={0}>
          <Grid item xs='auto' sx={classes.gridItemLogo}>
            <Box sx={classes.logoContainer}>
              <Link href='#'>
                <Logotype {...{ theme, isDashboard: true, isDrawer: false }} />
              </Link>
            </Box>
          </Grid>
          <Grid
            item
            container
            xs={4}
            alignItems='center'
            justifyContent='flex-end'
            wrap='nowrap'
            sx={classes.walletAndToggle}
          >
            {isWalletConnected && <ProfileMenu />}
            {!isWalletConnected && (
              <Grid item>
                <Tooltip
                  title={connectDisconect}
                  placement='bottom'
                  sx={classes.ball}
                >
                  <IconButton
                    color='primary'
                    onClick={handleWalletConnection}
                    sx={classes.walletIconButton}
                  >
                    {isWalletConnected ? (
                      <LogoutIcon />
                    ) : (
                      <AccountBalanceWalletIcon />
                    )}
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
            <Grid item sx={classes.toggle}>
              <ToggleColorMode />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};
